import { render, staticRenderFns } from "./ProjectEditNature.vue?vue&type=template&id=3c9bfadf&"
import script from "./ProjectEditNature.vue?vue&type=script&lang=js&"
export * from "./ProjectEditNature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports